import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { Induction } from '@/types/models'

export const useInductionStore = defineStore('induction', () => {
  const inductions = ref<Induction[]>([])

  const $reset = () => {
    inductions.value = []
  }

  const set = (new_inductions: Induction[]) => {
    inductions.value = new_inductions
  }

  return {
    inductions,
    $reset,
    set,
  }
})
